import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ForceUpdatePage } from '../../pages/force-update/force-update.page';

import { AuthService } from '../auth/auth.service';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class LocaldataService {
  public notificationdata:any = [];
  public displayNumber: Number;
  public folderStructure = [];
  public folderStructureRoot = [];
  public breadcrumb:any = [];
  public availableForms:any = [];
  public availableFormFactories:any = []
  public potatoseedFormAvailable: boolean = true;
  public farmers:any = [];

  constructor(private auth: AuthService, private http: HttpClient, private config: ConfigService, private router: Router, private modalCtrl: ModalController) {
    this.initData();
  }

  initData(){
    this.remoteUpdateNotifications();
    this.remoteUpdateFiles();
    this.remoteUpdateFormsAvailable();
  }

  handleError(error: any) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }


  public async checkVersionUpdate(){
    
    if(this.auth.userProfile){
      let headers: HttpHeaders = new HttpHeaders();
      headers = headers.append('Content-Type', 'application/json');
      headers = headers.append('Authorization', localStorage.getItem('access_token') || '{}');

      const options = {
        headers: headers
      };

      return this.http.get(this.config.basePath + '/api/versions?filter[where][forceupdate]=true&filter[order]=sort%20DESC&filter[limit]=1', options)
        .subscribe(res=>{
          var tmpArray = res;


          //console.log('Boom: ', this.config.version)

          //var versionGlobalArray: Array<string> = tmpArray[0].version.split('.');
          //var versionLocalArray: Array<string> = this.config.version.split('.');
          var updateNeeded: boolean = false;

          var versionGlobal: string = tmpArray[0].version.replace('.', '').replace('.', '');
          var versionLocal: string = this.config.version.replace('.', '').replace('.', '');


          if(parseInt(versionGlobal)>parseInt(versionLocal)){
            updateNeeded = true;
          }

          /*for(let i=0; i<versionGlobalArray.length; i++){
            console.log(i, ": ", parseInt(versionGlobalArray[i]), parseInt(versionLocalArray[i]));
            if(parseInt(versionGlobalArray[i])>parseInt(versionLocalArray[i])){
              updateNeeded = true;
            }
          }*/

          if(updateNeeded){// && !this.platform.is('mobileweb')
            //let forceUpdateModal = this.modalCtrl.create(ForceUpdatePage);
            //forceUpdateModal.present();
            console.log('update needed');
            //this.router.navigateByUrl('/force-update');
            this.openForceUpdateModal();
            
          }
        })
    }
  }


  async openForceUpdateModal(){
    let profileModal = await this.modalCtrl.create(
      {
        component: ForceUpdatePage,
        componentProps: {
          modalCtrl: this.modalCtrl
        },
      });
      profileModal.present();
  }




  public async updateNotificationReadRemote(notification): Promise<any>{
    return await this.http.patch(this.config.basePath + '/api/messages/'+ notification.id, {"read":true})
      .subscribe(
        (val) => {},
        response => {
          this.handleError(response);
        }
      );
  }


  public async remoteGetFarmers(factoryId):Promise<any>{
    
    if(this.auth.userProfile){
      let headers: HttpHeaders = new HttpHeaders();
      headers = headers.append('Content-Type', 'application/json');
      headers = headers.append('Authorization', localStorage.getItem('access_token') || '{}');

      const options = {
        headers: headers
      };


      return await this.http.get(this.config.basePath + '/api/factories/' + factoryId + '/farmers', options)
        .subscribe((res)=>{
          var tmpArray: any;
          tmpArray = res;

          this.farmers = [];


         
            for(var i:number = 0; i<tmpArray.length; i++){
              /*if(factoryId==100){
                this.farmers.push(tmpArray[i]);
              }
              if(factoryId==101){
                this.farmers.push(tmpArray[i]);
              }
              if(factoryId==103){
                this.farmers.push(tmpArray[i]);
              }
              if(factoryId==110){
                this.farmers.push(tmpArray[i]);
              }*/
              //console.log('push', tmpArray[i]);

              if(tmpArray[i].id != this.auth.userProfile.id){
                this.farmers.push(tmpArray[i]);
              }

            }


          });


    }
  }


  public async remoteUpdateFormsAvailable():Promise<any>{
    const lsProfile = JSON.parse(localStorage.getItem('profile'));

    if(this.auth.userProfile && lsProfile){
      
      let headers: HttpHeaders = new HttpHeaders();
      headers = headers.append('Content-Type', 'application/json');
      headers = headers.append('Authorization', localStorage.getItem('access_token') || '{}');

      const options = {
        headers: headers
      };
      /*return new Promise((resolve, reject) => {
        
        this.availableForms = [{"isSpecial":true,"systemname":"PotatoseedsOrderUpdated","displayname":"Bestilling af læggekartofler 2024","year":"2023-2024","displayDeadline":null,"displayIcon":null,"deadline":"2022-04-11T06:01:00.000Z","component":"FormsPotatoseedPage","publisher":"KMC AGRO","msgDateOutOfRange":"Bestillinger skal indleveres senest den 9. januar 2023. Kontakt Kim eller Per fra KMC Agro.","msgAlreadySubmitted":"Du har allerede udfyldt bestillingen og den kan kun sendes ind én gang.","onceperyear":false,"isSoldOut":null,"soldOutMsg":null,"orderYear":null,"tandc":"<h2>Læggekartofler til foråret 2024 – orientering & betingelser</h2>\n\n<p><strong>Faste sorter</strong><br/>\nTil foråret 2024 tilbyder KMC Agro materiale i følgende faste sorter:</br>\rAvarna, Avenue, Kardal, Kuras, Oleva, Saprodi, Saturna, Seresta, Stratos, Verdi og Ydun.</p>\n\n<p><strong>Supplerende sorter</strong><br/>\nDer er desuden mulighed for at bestille mindre mængder i følgende supplerende sorter:</br>\rAllstar, Festien, Lady Rosetta, Luneba, ­Sarion, Skawa, Tarzan og Thor.</br>\n\nDe ­supplerende sorter vil ikke nødvendigvis kunne leveres i alle klasser. Vi kan derfor ikke garantere, at KMC Agro kan levere ­sorterne i de ønskede klasser, og vi forbeholder os ret til at ændre klasserne. \rDer kan ikke oplyses pris på de supplerende sorter på bestillingstidspunktet.</p>\n\n<p><strong>Bliv klogere på sorterne på Sortsinfo</strong><br/>\nI Sortsinfo på avlerinfo.dk har vi samlet en række sortsoplysninger om stivelses- og pulversorter, bl.a. om de sorter, som KMC Agro tilbyder. Find detaljerede beskrivelser af sorterne og brug valg- og filterfunktioner til at finde de rigtige sorter – og sammenlign op til 5 sorter ad gangen.</br>\rDu finder Sortsinfo på http://www.avlerinfo.dk/sortsinfo</p>\n\n<p><strong>Klasse PB</strong><br/>\nKMC Agro kan – i begrænset omfang – tilbyde kl. PB i visse sorter til foråret 2024. Prisen vil være ca. 400 kr./hkg og leverance er afhængig af, at vi har de fornødne mængder til rådighed. Hvis du ønsker at komme i betragtning til kl. PB kan du skrive det i kommentarfeltet, som bliver vist sidst i bestillingen.</br>\n\nDet skal understreges, at kl. PB er sidestillet med kl. S, SE og A når materialet anvendes i brugsavlen. Materialet må udelukkende anvendes til egen opformering til brugsavl og må ikke sælges videre. </p>\n\n<p><strong>Klasse S/SE</strong><br/>\nKlasse S er produceret direkte på klasse PB fra præ­basisavlerne.</br>\r• For klasse S er kvalitetskravene: 0 % virus Y og bladrulle.</br>\r• For klasse SE er kvalitetskravene: maks. 1 % virus Y og bladrulle.</br>\r• For både klasse S og SE gælder, at der ikke må have været sortben i marken og heller ingen råd på lager.</br>\r\rKlasse S skal bestilles senest d. 9. januar 2023. Der tages forbehold for, at der er PB-materiale til rådighed.</br>\rHvis der ikke kan leveres klasse S, overføres bestillingen til klasse SE.</p>\n\n<p><strong>Behandling med Diabolo i klasse S, men ikke i klasse SE og A</strong><br/>\nLæggekartofler i klasse S fra KMC Agros egne fremavlere bliver behandlet med Diabolo imod lagersvamp, mens ­kartofler i klasse SE og A ikke vil blive bejdset med Diabolo. (Diabolo har afløst Fungazil TM 100, og har samme indhold af aktivstoffet imazalil). Andelshaverne skal fortsat selv behandle imod rodfiltsvamp.</p>\n\n<p><strong>Kvalitetskrav </strong><br/>\nLandbrugsstyrelsens bekendtgørelse for læggekartofler er gældende. For klasse S og SE gælder desuden KMC Agros skærpede krav. For de udleverede sorter vil der efter ønske kunne udleveres et dataark, hvor det er muligt at se informationer om marksyn og virustest.</p>\n\n<p><strong>Leveringsformer</strong><br/>\n12,5 hkg storsække eller løsleverance. Minimum leverance i storsække er 12,5 hkg. Minimum ved løs­leverance er 150 hkg. Ved bestilling af minimum 300 hkg indenfor samme sort og klasse ydes der 5 kr. rabat pr. hkg uanset ­leveringsform.</p>\n\n<p><strong>Størrelse</strong><br/>\rKlasse A, SE og S opsorteres alle i størrelse 35/55 mm.</p>\n \n<p><strong>Reklamationsfrist</strong><br/>\nFor sækkevarer senest 14 dage fra udleveringsdato, for løsvarer inden kartoflerne læsses af.</p>\n\n<p><strong>Levering</strong><br/>\nDen ordinære udkørsel vil starte d. 20. februar 2024 (hvis vejret tillader det) og slutte d. 15. april 2024. Andels­haverne skal være villige til at modtage kartoflerne i denne periode.</br>\rDer er mulighed for leverance af Kuras i perioden fra d. 1. februar til d. 20. februar, hvis vejret tillader det. Ved ­leverance i denne periode er ­prisen 5 kr. lavere pr. hkg. Hvis det pga. vejret ikke er muligt at levere inden d. 20. ­februar, vil kartoflerne blive faktureret til normal pris. Du kan vælge tidlig levering af Kuras sidst i bestillingen. </p>\n\n<p><strong>Videresalg</strong><br/>\nDe udleverede læggekartofler må ikke videresælges uden KMC Agros samtykke.</p>\n\n<p><strong>Priserne er eksklusiv fragt og moms</strong><br/>\nBemærk at priserne er inkl. kartoffelafgift og forædlerafgift, men ­ekskl. fragt og moms.</p>\n\n<p><strong>Leveringsforbehold</strong><br/>\nEr KMC Agro ikke leveringsdygtig i de bestilte sorter, forbeholdes ret til at til­byde at levere en anden sort, eller ­eventuelt at reducere mængden. Lige­ledes forbeholdes ret til, om for­nødent, at ændre leveringstidspunkt og klasse. Der tages forbehold for afgifts­ændringer.</p>\n\n<p><strong>Løbende ændringer og bindende bestilling</strong><br/>\nIgen i år kan du løbende ændre og gemme din bestilling på læggekartofler i app’en helt frem til midnat mandag d. 9. januar 2023. Hvis du ændrer din bestilling, vil der automatisk blive genereret en ny opsummering på bestillingen i app’ens digitale dueslag, mens den tidligere opsummering vil blive fjernet. Dvs. at opsummeringen i det digitale dueslag altid afspejler den aktuelle bestilling. Den bestilling der er gemt i Avlerinfo Selvbetjening ved midnat mellem d. 9. og d. 10. januar, bliver automatisk sendt til KMC Agro.</br>\n<strong>Bemærk at bestillingen er bindende!</strong></p>\n\n<p><strong>Bindende bestilling</strong><br/>\rBemærk venligst, at bestillingen skal være KMC Agro i hænde senest mandag d. 9. januar 2023 og at bestillingen er bindende! Hvis du indsender din bestilling via mail, benyt da venligst mail-adressen kmcagro@kmc.dk</p>\n\n<p><strong>Efterregulering af bestilling</strong><br/>\rSå vidt det er praktisk muligt for KMC Agro, kan man efterregulere sin bestilling frem til d. 1. februar 2024 – og ikke ­senere end det.</p>\r\n\n<p><strong>Har du spørgsmål?</strong><br/>\nHvis du har spørgsmål vedr. bestilling af læggekartofler kan du kontakte Kim Rask Hansen (4064 8819, krh@kmc.dk), Per Thorlund Christensen (5339 1806, ptc@kmc.dk) eller Lasse Primdal (9363 1714, ­lap@kmc.dk).</p>\n\n<p><strong>Kontraktspart</strong><br/>\n<em>KMC amba. fungerer som administrator for fabrikkerne AKD, Andels-Kartoffelmelsfabrikken Danmark, \rCVR: 62818328, Karup Kartoffelmelsfabrik, CVR: 16217719 og KMC Granules, CVR: 15230614. Det vil sige, at KMC alene administrerer bestillingsproceduren og faktureringen af læggekartofler på vegne af de nævnte fabrikker. Aftalen om køb og levering af læggekartofler indgås juridisk mellem dig og den ­konkrete fabrik. ­Hvilken fabrik aftalen indgås med afhænger af, hvilken fabrik din dyrkningskontrakt og/eller din ­leveringsaftale indgås med.</em></p>\n\n<p><strong>Finansiering:</strong><br/>\n<em>Faktura på læggekartoflerne udsendes af KMC på vegne af en af kartoffelmelsfabrikkerne. Man kan enten betale fakturaen eller finansiere læggekartoflerne gennem den fabrik man er tilknyttet. Ønsker man at betale fakturaen skal dette ske til fabrikken og ikke til KMC. Ønskes finansieringen gennem fabrikken vil det skyldige beløb inkl. renter og evt. omkostninger blive modregnet i betalingen for dine kartoffelleverancer til henholdsvis stivelse/granules.</em></p>","formproperties":{"year":"2024","potatoseedyear":"2022-2023","header":"til sæsonen 2024","deadline":"Husk at du kan rette i din bestilling frem til 9. januar 2023","kuras":"Jeg ønsker de bestilte partier i Kuras leveret i perioden fra d. 1. februar 2024 til d. 20. februar 2024 hvis vejrliget tillader det. Se i øvrigt orientering og betingelser i følgebrevet.","deadline_confirmation":"Bemærk at du kan opdatere din bestilling frem til midnat mandag d. 9. januar 2023."},"id":1000,"factoryId":104,"createdAt":"2019-12-05T00:00:00.000Z","updatedAt":"2019-12-05T00:00:00.000Z","createdBy":null,"updatedBy":null,"deletedAt":null,"deletedBy":null,"factory":{"displayname":"KMC AGRO","address":{"street":"Herningvej 60","zipcode":"7330","city":"Brande"},"id":104},"forms":[],"status":"deadline exceeded"},{"isSpecial":false,"systemname":"lejeaftale","displayname":"Opret en AKD Lejeaftale","year":"2023-2024","displayDeadline":null,"displayIcon":"rentalagreement","deadline":"2023-04-15T15:35:33.067Z","component":"FormsRentalagreementPage","publisher":"AKD","msgDateOutOfRange":"Det er ikke længere muligt at indgå en lejeaftale digitalt for den igangværende kampagne. Kontakt AKS hvis du vil indgå en lejeaftale.","msgAlreadySubmitted":null,"onceperyear":false,"isSoldOut":null,"soldOutMsg":null,"orderYear":null,"tandc":null,"formproperties":null,"id":52,"factoryId":105,"createdAt":"2018-11-12T00:00:00.000Z","updatedAt":"2018-11-12T00:00:00.000Z","createdBy":0,"updatedBy":null,"deletedAt":null,"deletedBy":null,"factory":{"displayname":"AKD","address":{"street":"Herningvej 38","zipcode":"7330","city":"Brande"},"id":105},"forms":[],"status":"ready"}];
      
        const publishers: string[] = this.availableForms.map(data => data.publisher);
        this.availableFormFactories = publishers.filter((x, i, a) => x!=='KMC AGRO' && x !== undefined && a.indexOf(x) === i);
        resolve('');
      });*/

       
       return await this.http.get(this.config.basePath + '/api/farmers/getFormsAvailable/', options)
        .subscribe((res) => {
          //var tmpArray = res;
console.log('FORMS', res)
          this.availableForms = res;
      
            const publishers: string[] = this.availableForms.map(data => data.publisher);
            this.availableFormFactories = publishers.filter((x, i, a) => x!=='KMC AGRO' && x !== undefined && a.indexOf(x) === i);

           
            this.potatoseedFormAvailable = this.availableForms.some(obj => obj.systemname === 'Potatoseeds');

            //if(this.availableForms.filter((x, i) => x.systemname === 'Potatoseeds'.length>0)){
              //this.potatoseedFormAvailable = true;
            //}


        });
    }
  }


  public async remoteUpdateNotifications(): Promise<any> {

    const lsProfile = JSON.parse(localStorage.getItem('profile'));

    if (this.auth.userProfile && lsProfile) {
      let headers: HttpHeaders = new HttpHeaders();
      headers = headers.append('Content-Type', 'application/json');
      headers = headers.append('Authorization', localStorage.getItem('access_token') || '{}');

      const options = {
        headers: headers
      };

      /*USERADMIN*/
      let userId = this.auth.userProfile.id
      if (this.auth.userProfile.usertype=='sub'){
        this.auth.userProfile.id = this.auth.userProfile.parentid;
      }

      return this.http.get<any[]>(this.config.basePath + '/api/messages/' + '?filter={"where":{"farmerId":' + userId + '},"order":"createdAt DESC"}', options)
        .subscribe((res) => {
          this.notificationdata = res;
          this.displayNumber = this.notificationdata.filter(x => x.read == false).length;
        });
    }
  }

  public async remoteUpdateFiles(): Promise<any>{

    const lsProfile = JSON.parse(localStorage.getItem('profile'));
    
    if(this.auth.userProfile && lsProfile){
      let headers: HttpHeaders = new HttpHeaders();
      headers = headers.append('Content-Type', 'application/json');
      headers = headers.append('Authorization', localStorage.getItem('access_token') || '{}');

      const options = {
        headers: headers
      };
      
      //console.log(options);

      this.folderStructure = [];
      this.folderStructureRoot = [];

      /*USERADMIN*/
      let userId = this.auth.userProfile.id
      if (this.auth.userProfile.usertype=='sub'){
        this.auth.userProfile.id = this.auth.userProfile.parentid;
      }

      return await this.http.get<any[]>(this.config.basePath + '/api/storages/' + '?filter={"where":{"farmerId":' + userId + '},"order":"id DESC"}', options)
        .subscribe((res)=>{
          this.folderStructure = res;
          for(var i=0; i<res.length; i++){
            if(res[i].parentid == null){
              this.folderStructureRoot.push(res[i]);
            }
          }
        });
    }
  }








  public filecount(fileId):number{
    return this.getfiles(fileId);
  }
  public getfiles(parentId:number){
    let counter:number=0;
    for (let obj of this.folderStructure) {
      if(obj.parentid==parentId){
        if(obj.type=="file"){
          counter++;
        }else{
          counter += this.getfiles(obj.id);
        }
      }
    }
    return counter;
  }
  public unreadFiles(fileId):boolean{
    return (this.getUnreadFiles(fileId)>0);
  }
  public getUnreadFiles(parentId:number){
    let counter:number=0;
    for (let obj of this.folderStructure) {
      if(obj.parentid==parentId){
        if(obj.type=="file" && obj.read==false){
          counter++;
        }else{
          counter += this.getUnreadFiles(obj.id);
        }
      }
    }
    return counter;
  }










  //Weignin, Loans, masterdata


  getWeighinsByDriver(skip: number = 0, limit: number = 20, searchTerm?: string): Observable<any> {
    let user_token: string = localStorage.getItem('access_token') || '{}';
    let profileStr: string | null = localStorage.getItem('profile');
    let user_id: string | null = profileStr ? JSON.parse(profileStr).id : null;

    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', user_token);

    const options = {
      headers: headers
    };

    /*USERADMIN*/
    let userId = this.auth.userProfile.id
    if (this.auth.userProfile.usertype == 'sub') {
      this.auth.userProfile.id = this.auth.userProfile.parentid;
    }

    //console.log('carrier_name', this.auth.userProfile.displayname);
    let carrier_name = this.auth.userProfile.displayname;

    // Build the filter
    const filter: any = {
      limit: limit,
      skip: skip,
      order: 'timestamp DESC',
      include: 'farmer',
      where: {
        carrier_name: carrier_name
      }
    };

    // Add search term if provided
    if (searchTerm?.trim()) {
      filter.where.searchTerm = searchTerm.trim();
    }

    const url = `${this.config.basePath}/api/DriverAdmins/getWeighIns?filter=${encodeURIComponent(JSON.stringify(filter))}`;

    return this.http.get(url, options).pipe(
      map((response: any) => {
        return {
          data: response,
          isLastPage: response.length < limit
        };
      })
    );
  }



  getWeighinsByUserId(): Observable<any> {
    let user_token: string = localStorage.getItem('access_token') || '{}';
    let profileStr: string | null = localStorage.getItem('profile');
    let user_id: string | null = profileStr ? JSON.parse(profileStr).id : null;

    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', user_token);

    const options = {
      headers: headers
    };

    /*USERADMIN*/
    let userId = this.auth.userProfile.id
    if (this.auth.userProfile.usertype=='sub'){
      this.auth.userProfile.id = this.auth.userProfile.parentid;
    }

    let carrier_name = this.auth.userProfile.displayname;

    const filter = {
      where: { carrier_name: carrier_name }
    };
    
    const url = `${this.config.basePath}/api/WeighIns/?filter={"where":{"farmerid":"${user_id}"}}`;

    //const url = `${this.config.basePath}/api/WeighIns/?filter=${encodeURIComponent(JSON.stringify(filter))}`;

    //const url = `${this.config.basePath}/api/WeighIns/?filter={"where":{"farmerid":"${userId}"}}`;
    return this.http.get(url, options);
  }

  fetchVejebonData(weighinId: string): Observable<any> {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', localStorage.getItem('access_token') || '{}');

    const options = {
      headers: headers
    };
    
    const url = `${this.config.basePath}/api/WeighIns/${weighinId}`;
    return this.http.get(url, options);
  }

  fetchAnalyticsData(weighinid: string, farmerId: string, factoryId: string, serialnumber: string): Observable<any> {

    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', localStorage.getItem('access_token') || '{}');

    let params  = new HttpParams()
    .set('weighinid', weighinid)
    .set('farmerId', farmerId)
    .set('factoryId', factoryId)
    .set('weighinserialnumber', serialnumber);

    const options = {
      headers: headers,
      params: params
    };



    const url = `${this.config.basePath}/api/WeighIns/analytics`;
    return this.http.get(url, options);
  }
  
  markWeighinAsRead(weighinId: string): Observable<any> {

    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', localStorage.getItem('access_token') || '{}');

    const options = {
      headers: headers
    };

    const url = `${this.config.basePath}/api/WeighIns/${weighinId}/markAsRead`;
    return this.http.put(url, {isRead: true}, options);
  }


  getRentalAgreementsByUserId(): Observable<any> {

    let profileStr: string | null = localStorage.getItem('profile');
    let user_id: string | null = profileStr ? JSON.parse(profileStr).id : null;

    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', localStorage.getItem('access_token') || '{}');

    const options = {
      headers: headers
    };


    const filter = JSON.stringify({
      where: {
        and: [
          { receiverId: user_id },
          { status: 'approvedBySender' }
        ]
      }
    });

    const url = `${this.config.basePath}/api/rentalagreements`;
    
    return this.http.get(`${url}?filter=${encodeURIComponent(filter)}`);
  }

}